module.exports = __webpack_public_path__ + "static/media/linked-in.3d1935d3.svg";